module.exports = "/dist/arrow.left.png?57db66bca0211fc6078a99e0c66c4694";


//////////////////
// WEBPACK FOOTER
// ./src/assets/arrow.left.png
// module id = 98
// module chunks = 0